import { render, staticRenderFns } from "./FacturaTableComponent.vue?vue&type=template&id=3c032b3b&"
import script from "./FacturaTableComponent.vue?vue&type=script&lang=js&"
export * from "./FacturaTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports